export const GeneralCapexVersions = {
    initialVersion : new Date(0,0,0),
    version2 : new Date(2023,5,1)
}
